import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import style from './Header.module.css';
import { FiMenu, FiHome } from 'react-icons/fi';


class Header extends Component {
  static props = {
    title: PropTypes.string,
    noHeader: PropTypes.bool
  }

  state = {
    isShowingMenu: false
  }

  render() {
    const {
      title,
      noHeader
    } = this.props;
    const {
      isShowingMenu
    } = this.state;

    return [
      (
        <Helmet>
          <title>{ title || '' } | 第60回 柏苑祭 Adventure</title>
        </Helmet>
      ),
      noHeader ? null : (
        <header key='top_header' className={style.header}>
          <h1 className={style.header_title}><Link to={'/'} className={style.header_title_a}>第60回 柏苑祭 Adventure</Link></h1>
          <div className={style.header_menu_button} onClick={() => this.setState({ isShowingMenu: !isShowingMenu })}><FiMenu size={30} /></div>
        </header>
      ),
      isShowingMenu ? (
        <div key='menu' className={style.header_menu} >
          <Link to={'/'} className={style.header_menu_item}>
            <p>トップ</p>
          </Link>

          <Link to={'/category/exhibition.html'} onClick={() => this.setState({ isShowingMenu: false })} className={style.header_menu_item}>
            <p>展示</p>
          </Link>

          <Link to={'/category/store.html'} onClick={() => this.setState({ isShowingMenu: false })} className={style.header_menu_item}>
            <p>模擬店</p>
          </Link>

          <Link to={'/category/event.html'} onClick={() => this.setState({ isShowingMenu: false })} className={style.header_menu_item}>
            <p>イベント</p>
          </Link>

          <Link to={'/category/stage.html'} onClick={() => this.setState({ isShowingMenu: false })} className={style.header_menu_item}>
            <p>舞台</p>
          </Link>

          <Link to={'/favorites.html'} onClick={() => this.setState({ isShowingMenu: false })} className={style.header_menu_item}>
            <p>お気に入り</p>
          </Link>
        </div>
      ) : null
    ];
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js